import React, { useEffect, useState, useRef } from "react";
import 'react-html5-camera-photo/build/css/index.css';
import { SystemIcons } from "../../common/SystemIcons";
import { CameraFeed } from "../../common/TakePhoto";
import { SysCheckSideIcon } from "../../common/SysCheckSideIcon";
import SkeletonVideoPlayer from "../../../loaders/SkeletonVideoPlayer";
import { Heading2 } from "../../common/GlobalElements/Typography";
import { tokens } from "../../../public/tokens";
import { StandardButton } from "../../common/GlobalElements/StandardButton";
const Step3 = (props) => {
  return (
    <>
      <div className="tab-pane fade show active" id="Assessment-Detail">
        <div className="test-series-main-block">
          <div className="test-series-main-left-blk">
            <div className="test-series-main-heading icon-add mb-15">
              <Heading2 fontWeight={tokens.typography.fontWeights.semibold}> {props.data && props.data.name ? props.data.name : ""}{props.data && props.data.code ? ` (${props.data.code})` : ""}</Heading2>
              <span className="test-series-main-left-heading-act">
                <SystemIcons data={props.data} />
              </span>
            </div>

            <div className="breadcrumb-btn-blk">
              <div className="custom-breadcrumb">
                <StandardButton noAction={true} variant="transparent" as="ul">
                  <li onClick={() => props.stepUpdate(1)} className="custom-breadcrumb-item active">
                    <a href="#" onClick={(e) => e.preventDefault()}>
                      <i className="fal fa-home"></i>
                    </a>
                  </li>
                  {props.showSystemCheck &&
                    <li onClick={() => props.stepUpdate(2)} className="custom-breadcrumb-item active">
                      <a href="#" onClick={(e) => e.preventDefault()}>System Check</a>
                    </li>
                  }
                  <li className={`custom-breadcrumb-item ${(props.photoId != "") ? 'active' : 'inactive'}`}>
                    <a href="#" onClick={(e) => e.preventDefault()}>Student Identification</a>
                  </li>
                  <li className="custom-breadcrumb-item">
                    <a href="#" onClick={(e) => e.preventDefault()}>Test</a>
                  </li>
                </StandardButton>
              </div>
              <div className="breadcrumb-btns">
                <StandardButton variant="primary" onClick={props.backBtn} type="button">
                  <i className="fal fa-chevron-left"></i> Back
                </StandardButton>
                <div className="breadcrumb-right-btns">
                  {props.photoId != "" &&
                    <StandardButton variant="primary"
                      onClick={props.photoId == "" ? props.handleClick : props.retake}
                      type="button"
                    >
                      <i className="fal fa-camera"></i>Reset
                    </StandardButton>
                  }

                  {props.photoId != "" ? (
                    <StandardButton variant="primary" onClick={props.onNext} type="button" disabled={props.loadingNextBtn}>
                      {props.loadingNextBtn? <i className="fas fa-cog fa-spin"></i>: ''}  Next <i className="fal fa-chevron-right"></i> Test/Assessment
                    </StandardButton> 
                  ) : (
                    <StandardButton variant="disabled" disabled={true} type="button">
                      Next <i className="fal fa-chevron-right"></i>
                      Test/Assessment
                    </StandardButton>
                  )}
                </div>
              </div>
            </div>

            <div className="test-series-main-heading mb-15">
              <Heading2 fontWeight={tokens.typography.fontWeights.semibold}> Student Identification</Heading2>
            </div>

            <div className="std-identify-blk mb-15">
              <p>
                Please take a photo of your face and your student card/ID, as soon as you are ready to take the photo please select the Camera icon in the center of the photo box
              </p>
              <figure>
                {props.photoId != "" &&
                  <div className="output-img-border">
                    <div className="output-img">
                      <img src={props.photoId} />
                    </div>
                  </div>
                }

                {
                  props.loadingCamera ? (
                    <SkeletonVideoPlayer />
                  ) : props.hasCamera ? (
                    <CameraFeed
                      setLoadingNextBtn={props.setLoadingNextBtn}
                      sendFile={props.handleTakePhoto}
                      showCamFeed={props.photoId === ""}
                    />
                  ) : (
                    <h1 style={{ textAlign: 'center' }}>Camera not found</h1>
                  )
                }
              </figure>
            </div>
          </div>

          <div className="test-series-main-right-blk">
            <div className="step-sidebar-space">
              <SysCheckSideIcon props={props} />
            </div>

            <div className="test-series-steps">
              <ul>
                <li className="test-series-steps-item active done">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <span>1</span> <b>Assessment Detail</b>
                  </a>
                </li>
                {props.showSystemCheck ?
                  <li className="test-series-steps-item active done">
                    <a href="#" onClick={(e) => e.preventDefault()}>
                      <span>2</span> <b>System Check</b>
                    </a>
                  </li>
                  : null}
                <li className={`test-series-steps-item active ${(props.photoId != "") ? 'done' : ''}`}>
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <span>{props.showSystemCheck ? 3 : 2}</span> <b>Identification</b>
                  </a>
                </li>
                <li className="test-series-steps-item">
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    <span>{(props.showSystemCheck && props.showIdentification) ? 4 : (props.showSystemCheck || props.showIdentification) ? 3 : 2}</span> Launch Exam
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default React.memo(Step3);
